import React, { useState } from "react";
import {
	Card, Label, Alert
} from "reactstrap";
import SpeechRecognition, { useSpeechRecognition } from "react-speech-recognition";

export default function StepFour({
	setSetupProgress
}) {
	const [is_listening, setIsListening] = useState(false);
	const [showTranscriptBox, setShowTranscriptBox] = useState(false);
	const [showUserConfirmation, setShowUserConfirmation] = useState(false);

	const {
		transcript,
		resetTranscript,
		browserSupportsSpeechRecognition,
	} = useSpeechRecognition();

	const startListening = () => {
		resetTranscript();
		SpeechRecognition.startListening({ continuous: true });
		setShowTranscriptBox(true);
		setIsListening(true);
	};

	const stopListening = () => {
		SpeechRecognition.stopListening();
		setIsListening(false);
		setShowUserConfirmation(true);
	};

	const nextStep = () => {
		setSetupProgress(prev => ({
			...prev,
			stepFive: true
		}));
	};

	return (
		<Card className="p-4 mb-3 visibility-visible">
			<div className="title mb-4">
				<span className="me-2 step-number">4</span>Test Speech Recognition
			</div>

			{browserSupportsSpeechRecognition ? (
				<>
					<div className="mb-3 gray-text">
						In 2005, donor countries agreed on an accord to harmonize their practices. Since then, aid officials have complained that too little has
						changed on the ground. Conferences of donors in developing countries still tend to be dominated by a small group of north European
						governments, with the US often absent.
					</div>

					<Label>
						Read the paragraph above and click on "Start AI Engine". Read paragraph normally. When you are done click on "STOP AI Engine" button.
					</Label>

					<div className="contact-form-btns mb-3">
						<button
							type="button"
							className="contact-save-btn btn m-0"
							onClick={startListening}
							disabled={is_listening}
						>Start AI Engine</button>

						<button
							type="button"
							className="recording-buttons px-4 ms-3"
							onClick={stopListening}
							disabled={!is_listening}
						>Stop AI Engine</button>
					</div>

					{showTranscriptBox && (
						<div className="mb-3">
							<Label>Spoken Text (Live):</Label>
							<div
								style={{
									background: "#f2f2f2",
									padding: 10,
									borderRadius: 5,
									fontSize: 16,
									border: "1px solid #ccc",
									minHeight: 80,
								}}
							>
								{transcript ? transcript : "We're listening..."}
							</div>
						</div>
					)}

					{showUserConfirmation &&
						<div className="contact-form-btns">
							<button
								type="button"
								className="contact-save-btn btn m-0"
								onClick={nextStep}
							>
								Speech Recognition is Good. Go to Next Step
							</button>
						</div>
					}
				</>
			) : (
				<Alert color="danger" className="py-1 recording-note">
					Your browser does not support speech recognition. We recommend Google Chrome.
				</Alert>
			)}
		</Card>
	);
};